import { safelyGetNavigator } from './safely-get-navigator'

export const copyToClipboard = (text: string) => safelyGetNavigator()?.clipboard?.writeText(text)
